import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { appContext } from '../../util/decorators';
import translatedRoutes from '../../config/translatedRoutes';
import TabMenu from '../Navigation/TabMenu';

const mapStateToProps = state => ({
  country: state.country,
  q: state.search.q,
  videoType: state.search.videoType,
  videoTypes: _.without(state.tagValues, 'vce-clip', '48hclip', 'angle'),
});

@connect(mapStateToProps)
@withRouter
@appContext
export default class SearchPageForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      videoType: props.videoType || '',
      q: props.q || '',
    };
  }
  static propTypes = {
    router: React.PropTypes.object.isRequired,
    country: React.PropTypes.string,
    q: React.PropTypes.string,
    videoType: React.PropTypes.string,
    videoTypes: React.PropTypes.array,
  }

  componentWillReceiveProps(nextProps) {
    // Get search query from props if delayed
    if (this.props.q !== nextProps.q) {
      this.setState({
        q: nextProps.q,
      });
    }
  }

  onSubmit(evt, pathname) {
    evt.preventDefault();
    const query = {
      q: this.state.q,
    };
    if (this.state.videoType && this.state.videoType !== 'all') query.videoType = this.state.videoType;
    this.props.router.push({ pathname, query });
  }

  videoTypeSelectHandler(evt, url) {
    this.setState({videoType: evt.target.name}, () => this.onSubmit(evt, url));
  }

  render() {
    const t = this.context.app.t;
    const { country } = this.props;
    const { url } = translatedRoutes[country].Search;

    return (
      <div className="search-page-form">
        <form
          className="form"
          onSubmit={evt => this.onSubmit(evt, url)}
        >
          <div className="search-group">
            <div className="search-input">
              <input type="search" name="q" ref="searchPageInput" required autoComplete="off" maxLength="48" value={this.state.q} onChange={e => this.setState({q: e.target.value})} />
              <button className="search-reset" type="reset" onClick={() => this.setState({q: ''}, this.refs.searchPageInput.focus())} />
            </div>
            <button className="search-page-button icon-magnifier" />
          </div>
        </form>
        { this.props.videoTypes.length > 0 &&
          <div className="video-type-filter">
            <TabMenu activeSection={this.state.videoType || 'all'} className="video-type-selector">
              { ['all', ...this.props.videoTypes].map((type, idx) => <a name={type} key={`${type}${idx}`} onClick={evt => this.videoTypeSelectHandler(evt, url)}>{t(`ContentMeta.${type}`)}</a>)}
            </TabMenu>
          </div> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Search/SearchPageForm.jsx